import { COLOR } from '@setplex/arcana'

// TODO: fix any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useTheme = (props: any) => {
  const {
    textColor,
    subTitleColor,
    labelColor,
    primaryColor,
    pageBackgroundColor,
    containerBackgroundUncheckedColor,
    containerBackgroundColor,
    containerBorderColor,
    inputBorderColor,
    inputBackgroundColor,
    inputTextColor,
    inputRadioBorderColor,
    inputRadioBorderCheckedColor,
    dangerColor,
    dangerBackgroundColor,
    dangerTextColor,
    focusColor,
    focusRingColor,
  } = props

  const getBodyColor = (color: COLOR, defaultColor: COLOR | string) =>
    getComputedStyle(document.body).getPropertyValue(color) ||
    getComputedStyle(document.body).getPropertyValue(defaultColor)

  const textColors = getBodyColor(textColor, COLOR.TEXT_ICON_PRIMARY)
  const subTitleColors = getBodyColor(subTitleColor, COLOR.TEXT_ICON_SECONDARY)
  const labelColors = getBodyColor(labelColor, COLOR.TEXT_ICON_PRIMARY)
  const primaryColors = getBodyColor(primaryColor, COLOR.BASE_MAIN_DEFAULT)
  const pageBackgroundColors = getBodyColor(
    pageBackgroundColor,
    COLOR.BACKGROUND_DARK
  )
  const containerBackgroundUncheckedColors = getBodyColor(
    containerBackgroundUncheckedColor,
    COLOR.TRANSPARENT
  )
  const containerBackgroundColors = getBodyColor(
    containerBackgroundColor,
    COLOR.TRANSPARENT
  )
  const containerBorderColors = getBodyColor(containerBorderColor, 'none')
  const inputBorderColors = getBodyColor(
    inputBorderColor,
    COLOR.SURFACE_OPACITY_LIGHT_10
  )
  const inputBackgroundColors = getBodyColor(
    inputBackgroundColor,
    COLOR.SURFACE_DARK_6
  )
  const inputTextColors = getBodyColor(inputTextColor, COLOR.TEXT_ICON_PRIMARY)
  const inputRadioBorderColors = getBodyColor(
    inputRadioBorderColor,
    COLOR.SURFACE_OPACITY_LIGHT_10
  )
  const inputRadioBorderCheckedColors = getBodyColor(
    inputRadioBorderCheckedColor,
    COLOR.SURFACE_OPACITY_LIGHT_10
  )
  const dangerColors = getBodyColor(dangerColor, COLOR.ADDITIONAL_RED_2)
  const dangerBackgroundColors = getBodyColor(
    dangerBackgroundColor,
    COLOR.SURFACE_DARK_6
  )
  const dangerTextColors = getBodyColor(dangerTextColor, COLOR.ADDITIONAL_RED_2)
  const focusColors = getBodyColor(focusColor, COLOR.BASE_MAIN_DEFAULT)
  const focusRingColors = getBodyColor(focusRingColor, COLOR.SURFACE_DARK_7)

  return {
    colors: {
      /**
       * Text - Main body text, labels and headers
       */
      text: textColors,
      /**
       * Subtle Text - Hints and Smaller text, e.g. Card Expiry
       */
      subtleText: subTitleColors,
      /**
       * Label Text - Labels for inputs can be a different color
       */
      labelText: labelColors,
      /**
       * Primary - Interactive elements or Brand
       */
      primary: primaryColors,
      /**
       * Page - The main body/page of the Embed iFrame
       */
      pageBackground: pageBackgroundColors,
      /**
       * Container - Used for bounding elements, e.g. an individual payment option
       */
      containerBackgroundUnchecked: containerBackgroundUncheckedColors,
      containerBackground: containerBackgroundColors,
      containerBorder: containerBorderColors,
      /**
       * Input - Used for inputs
       */
      inputBorder: inputBorderColors,
      inputBackground: inputBackgroundColors,
      inputText: inputTextColors,
      inputRadioBorder: inputRadioBorderColors, // defaults to containerBorder
      inputRadioBorderChecked: inputRadioBorderCheckedColors, // default to primary
      /**
       * Danger - Used for Error states or Destructive Action
       */
      danger: dangerColors,
      dangerBackground: dangerBackgroundColors,
      dangerText: dangerTextColors,
      /**
       * Info - Used for information / loading states
       */
      info: '#3ea2ff',
      infoBackground: '#e7f2fb',
      infoText: '#0367c4',
      /**
       * Focus - Color of the focus ring if shadows.focus is not set.
       */
      focus: focusColors,
    },
    fonts: {
      /**
       * Body - Used for all text
       */
      body: 'google:DM Sans',
    },
    borderWidths: {
      /**
       * Container - A bounding layout element
       *  thin === 1px, thick === 2px, none === 0px
       */
      container: 'none', // 'thin', 'thick' or 'none'
      /**
       * Input - A Form Input, e.g. Card Number
       */
      input: 'thin', // 'thin' or 'thick'
    },
    radii: {
      /**
       * Container - A bounding layout element
       * subtle === 2px, rounded === 4px, none === 0px
       */
      container: 'none', // 'subtle', 'rounded' or 'none'
      /**
       * Input - A Form Input, e.g. Card Number
       */
      input: 'none', // 'subtle', 'rounded' or 'none'
    },
    shadows: {
      /**
       * Focus Ring - Surrounds an element that is currently focused
       */
      focusRing: `0 0 0 1px ${focusRingColors}`,
    },
  }
}
